import React from "react";
import PropTypes from "prop-types";

import { useTrans } from "../../../../hooks";
import {
  MAP_CHARACTER_REPRESENTATION_IDENTITIES,
  OTHER_IDENTITIES_CHARACTER_MAX,
  OTHER_IDENTITIES_CHARACTER_MIN
} from "../constants";
import ContestFormField from "../ContestFormField";
import { NewCheckbox } from "../../../../shared-components";
import ErrorField from "./ErrorField";

const CharacterRepresentationField = ({
  form,
  disableForm,
  onCharacterRepresentationChange,
  onFormChange
}) => {
  const { trans } = useTrans();

  const title = trans("Character representation");

  const subtitle = (
    <div className="subtitle">
      {/* prettier-ignore */ trans("Does your story feature a main character who identifies with any of the following communities? (Select all that apply)")}
      <br />
      <br />
      {/* prettier-ignore */ trans("This section is entirely voluntary. Your answer(s) (or your decision to skip this question) will not impact your chances of winning a Watty. This data is used to help our teams understand the diversity of stories being submitted. We do not collect information about writer identity.")}
    </div>
  );

  const diversityOtherErrorMessage = trans(
    "This field has to contain less than 150 characters and more than 2 characters."
  );

  return (
    <ContestFormField title={title} subtitle={subtitle}>
      <div id="character-representation">
        {MAP_CHARACTER_REPRESENTATION_IDENTITIES(trans).map(identity => (
          <div className="checkbox-group" key={identity.key}>
            <NewCheckbox
              name={identity.key}
              disabled={disableForm}
              onChange={onCharacterRepresentationChange}
              contentId={`character-representation-${identity.key}`}
              checked={form.diversity.includes(identity.key)}
            >
              {identity.value}
            </NewCheckbox>
          </div>
        ))}
      </div>
      {form.diversity.includes("OTHER") && (
        <>
          <textarea
            className="form-element"
            id="other-character-representation-textarea"
            name="diversityOther"
            value={form.diversityOther}
            placeholder={trans("You can add more details here")}
            disabled={disableForm}
            onChange={onFormChange}
          />
          <ErrorField
            fieldId={"diversity-other"}
            errorCondition={form.diversityOther === ""}
          />
          {(form.diversityOther?.length > OTHER_IDENTITIES_CHARACTER_MAX ||
            form.diversityOther?.length < OTHER_IDENTITIES_CHARACTER_MIN) &&
            form.diversityOther !== "" && (
              <ErrorField
                fieldId={"diversity-other"}
                errorMessage={diversityOtherErrorMessage}
              />
            )}
        </>
      )}
    </ContestFormField>
  );
};

CharacterRepresentationField.propTypes = {
  form: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  onCharacterRepresentationChange: PropTypes.func.isRequired,
  onFormChange: PropTypes.func.isRequired
};

export default CharacterRepresentationField;
